module.exports = require("assert");


//////////////////
// WEBPACK FOOTER
// external "assert"
// module id = 10
// module chunks = 0 1 2 3